import { Link, Stack, Typography } from '@mui/material';
import Snackbar from 'components/shared/snackbar/SnackBar';
import { differenceInHours, differenceInMinutes } from 'date-fns';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

const IncidentSnackBar = forwardRef(({ event, ...props }, ref) => {
  const { t } = useTranslation();

  const formatRelativeTime = (updatedAt) => {
    const minutes = differenceInMinutes(new Date(), new Date(updatedAt));
    if (minutes < 60) return t('common.notifications.page_status.time.minutesAgo', { count: minutes });
    return t('common.notifications.page_status.time.hoursAgo', {
      count: differenceInHours(new Date(), new Date(updatedAt)),
    });
  };

  return (
    <Snackbar
      ref={ref}
      {...props}
      title={event.name}
      variant="error"
      message={
        <Stack spacing={0}>
          <Typography variant="caption">{formatRelativeTime(event.updatedAt)}</Typography>
          <Link component={'a'} target="_blank" underline="always" href={event.shortlink}>
            View latest updates
          </Link>
        </Stack>
      }
    />
  );
});

export default IncidentSnackBar;
